const init = (swat) => {
  window.swymSwat = swat;
  fetchList(swat);
  addSwymEventListener(swat);
};

const createList = (swat) => {
  let listConfig = { "lname": "My Wishlist" };

  let onSuccess = function ({ lid }) {
    window.swymSelectedListId = lid;
  };

  let onError = function (error) {
    console.log("Error while creating a List", error);
  };

  swat.createList(listConfig, onSuccess, onError);
};

const fetchList = async (swat) => {
  return new Promise((resolve, reject) => {
    const onSuccess = (lists) => {
      window.swymWishLists = lists;
      let listsArr = Array.isArray(lists) ? lists : (lists ? [lists] : []);
      window.swymSelectedListId = listsArr[0] && listsArr[0].lid;
      resolve(lists);
      updateButtonState();
    };

    const onError = (error) => {
      console.log("Error while fetching all Lists", error);
      reject(error);
    };

    if (!window.swymWishLists) {
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    } else {
      resolve(window.swymWishLists);
    }
  });
};

const refreshList = async (swat) => {
  window.swymWishLists = null;
  await fetchList(swat);
};

const addToWishlist = (swat, product, elements) => {
  let onSuccess = function (addedListItem) {
    if (elements) updateButtonWishlistState(elements, true);
  };

  let onError = function (error) {
    swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
  };

  let lid = window.swymSelectedListId;

  if (!lid) {
    createList(swat);
  }

  swat.addToList(lid, product, onSuccess, onError);
};

const removeFromWishlist = (swat, product, elements) => {
  let onSuccess = function (deletedProduct) {
    if (elements) updateButtonWishlistState(elements, false);
  };

  let onError = function (error) {
    swat.ui.showErrorNotification({ message: "Error removing Product from Wishlist" });
  };

  let lid = window.swymSelectedListId;

  swat.deleteFromList(lid, product, onSuccess, onError);
};

const updateButtonState = () => {
  const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');

  if (swymWishlistButtons) {
    swymWishlistButtons.forEach((swymWishlistButton) => {
      const elements = swymWishlistButton.elements;
      if (!elements) return;
      const { epi, empi } = elements.wishlistButton.dataset;
      let isWishlisted = false;

      if (window.swymWishLists) {
        let lists = Array.isArray(window.swymWishLists) ? window.swymWishLists : [window.swymWishLists];
        lists.forEach(list => {
          let contents = list.listcontents || list.listContents || list.contents || [];
          contents.forEach(item => {
            if (item.empi == empi && item.epi == epi) {
              isWishlisted = true;
            }
          });
        });
        updateButtonWishlistState(elements, isWishlisted);
      }
    });
  }

  updateHeaderWishlistIcon();
};

const updateHeaderWishlistIcon = () => {
  let count = 0;

  if (window.swymWishLists) {
    let lists = Array.isArray(window.swymWishLists) ? window.swymWishLists : [window.swymWishLists];
    lists.forEach(list => {
      let contents = list.listcontents || list.listContents || list.contents || [];
      count += contents.length;
    });
  }

  document.querySelectorAll('.wishlist-header-icon').forEach((icon) => {
    const unfilled = icon.querySelector('.wishlist-header-icon__unfilled');
    const filled = icon.querySelector('.wishlist-header-icon__filled');
    const bubble = icon.querySelector('.wishlist-header-icon__bubble');
    const countEl = icon.querySelector('.wishlist-header-icon__count');
    if (!unfilled || !filled || !bubble || !countEl) return;

    if (count > 0) {
      filled.style.display = 'flex';
      unfilled.style.display = 'none';
      bubble.style.display = '';
      countEl.textContent = count < 100 ? count : '99+';
    } else {
      filled.style.display = 'none';
      unfilled.style.display = 'flex';
      bubble.style.display = 'none';
    }
  });
};

const updateButtonWishlistState = (elements, isWishlisted) => {
  let settings = {};
  try {
    settings = JSON.parse(elements.wishlistButton.dataset.settings || '{}');
  } catch (e) {}
  elements.filledState.style.display = isWishlisted ? 'flex' : 'none';
  elements.unfilledState.style.display = isWishlisted ? 'none' : 'flex';
  if (isWishlisted) {
    elements.wishlistButton.classList.add('swym-added-custom');
    if (settings.disable_added_to_wishlist) {
      elements.wishlistButton.setAttribute('disabled', true);
    }
  } else {
    elements.wishlistButton.classList.remove('swym-added-custom');
    elements.wishlistButton.classList.remove('disabled');
    elements.wishlistButton.removeAttribute('disabled');
  }
};

const fetchProductsData = async (url) => {
  const productData = await fetch(`${url}.js`);
  if (productData.status === 404 || !productData.ok) return null;
  const jsonData = await productData.json();
  return jsonData;
};

const addSwymEventListener = (swat) => {
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, (event) => {
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
    const currentVariant = data.detail.d.variant.id;
    const currentProductId = data.detail.d.product.id;
    const swymCustomWishlistButtons = document.querySelectorAll(`.swymcs-wishlist-button-${currentProductId}`);
    swymCustomWishlistButtons.forEach((swymCustomWishlistButton) => {
      swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
    });
    setTimeout(updateButtonState, 200);
  });
};

const swymcsWishlistFunctions = {
  init,
  fetchList,
  createList,
  refreshList,
  updateButtonState,
  updateButtonWishlistState,
  addToWishlist,
  removeFromWishlist,
  addSwymEventListener,
  fetchProductsData
};


document.addEventListener('change',({ target }) => {

    if( ! target.matches?.(`input[ name = 'id' ]`) )
        return

    const section = target.closest
        (`[ id ^= 'shopify-section-' ]`)

    const parent = section ?? document

    parent
    .querySelectorAll(`swymcs-wishlist-button button`)
    .forEach(( button ) => button.dataset.epi = target.value )

    setTimeout(updateButtonState,200)
})


if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymcsWishlistFunctions.init);

window.swymcsWishlistFunctions = swymcsWishlistFunctions;

if (!customElements.get('swymcs-wishlist-button')) {
  class SwymWishlistButton extends HTMLElement {
    constructor() {
      super();
      if (!window.SwymCallbacks) window.SwymCallbacks = [];
      window.SwymCallbacks.push(this.initializeSwymButton.bind(this));
    }

    async initializeSwymButton(swat) {
      this.elements = {
        wishlistButton: this.querySelector('button'),
        unfilledState: this.querySelector('#swymUnfilled'),
        filledState: this.querySelector('#swymFilled'),
      };

      if (this.elements.wishlistButton.dataset.swymBound) {
        updateButtonState();
        return;
      }
      this.elements.wishlistButton.dataset.swymBound = 'true';

      this.elements.wishlistButton.addEventListener('click', () => {
        let { epi, empi, du } = this.elements.wishlistButton.dataset;
        let product = { epi, empi, du };

        const added = this.elements.wishlistButton
            .classList.contains('swym-added-custom')

        console.debug('Wishlist-Button',{ product , added })

        if( added ){
          swymcsWishlistFunctions.removeFromWishlist(swat, product, this.elements);
        } else {
          swymcsWishlistFunctions.addToWishlist(swat, product, this.elements);
        }
      });

      updateButtonState();
    }
  }
  customElements.define('swymcs-wishlist-button', SwymWishlistButton);
}
